import { Raycaster, Vector2 } from 'three';

import { lisa } from '../Lisa.js';
import { EVENTS } from '../constants.js';

export default class ScreenRaycaster extends Raycaster {
	constructor(mesh) {
		super();

		this.mouse = new Vector2(-1, -1);
		this.intersects = [];

		this.mesh = mesh;
		// this.mesh.visible = false;
		lisa.state.on(EVENTS.POINTER_MOVE, this.onMouseMove);
	}
	raycast = () => {
		this.setFromCamera(this.mouse, lisa.camera);
		this.intersects = this.intersectObject(this.mesh);
		if (this.intersects.length) {
			lisa.mouseComputation.material.uniforms.uMouse.value.x = this.intersects[0].uv.x;
			lisa.mouseComputation.material.uniforms.uMouse.value.y = this.intersects[0].uv.y;
		} else {
			lisa.mouseComputation.material.uniforms.uMouse.value.x = -1;
			lisa.mouseComputation.material.uniforms.uMouse.value.y = -1;
		}
		// console.log(lisa.mouseComputation.material.uniforms.uMouse.value)
	};

	onMouseMove = (mouse) => {
		if (this.mouse) {
			this.mouse.copy(mouse);
		}

		this.raycast();
	};
}
